import { useEffect, useRef, useState } from 'react';

interface UseMinimumLoadingDurationParams {
  isLoading: boolean;
  minimumDurationMs: number;
}

export const useMinimumLoadingDuration = ({
  isLoading,
  minimumDurationMs,
}: UseMinimumLoadingDurationParams): boolean => {
  const [shouldShowLoading, setShouldShowLoading] = useState(isLoading);
  const loadingStartTimeRef = useRef<number | null>(isLoading ? Date.now() : null);

  useEffect(() => {
    if (isLoading) {
      if (loadingStartTimeRef.current === null) {
        loadingStartTimeRef.current = Date.now();
      }
      setShouldShowLoading(true);
    } else {
      if (loadingStartTimeRef.current !== null) {
        const elapsedTime = Date.now() - loadingStartTimeRef.current;
        const remainingTime = Math.max(0, minimumDurationMs - elapsedTime);

        if (remainingTime > 0) {
          const timeoutId = setTimeout(() => {
            setShouldShowLoading(false);
            loadingStartTimeRef.current = null;
          }, remainingTime);

          return () => {
            clearTimeout(timeoutId);
          };
        } else {
          setShouldShowLoading(false);
          loadingStartTimeRef.current = null;
        }
      } else {
        setShouldShowLoading(false);
      }
    }
  }, [isLoading, minimumDurationMs]);

  return shouldShowLoading;
};
